import React from 'react'

export default function FaceFeature({ scaleX, fill, verticalOffset }) {
  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`} fill="none">
      <path d="M0 1.3103L8.59 2.72021L8.84 0.57019L0 1.3103Z" fill={fill} />
      <path d="M21.2201 1.3103L12.6301 2.72021L12.3901 0.57019L21.2201 1.3103Z" fill={fill} />
    </g>
  )
}
